//----------------------------------------------------------------------------------------------------------------------
// Post-Processing Dispatcher
//
// Routes to either the DefaultRenderingPipeline backend or the Frame Graph backend
// based on config.renderer.
//----------------------------------------------------------------------------------------------------------------------

import type { Scene } from '@babylonjs/core';

import type { PostProcessingConfig } from '../interfaces/level.ts';

import { applyPipelinePostProcessing } from './postProcessingPipeline.ts';

//----------------------------------------------------------------------------------------------------------------------

export async function applyPostProcessing(scene : Scene, config : PostProcessingConfig) : Promise<void>
{
    if(config.renderer === 'frameGraph')
    {
        const { applyFrameGraphPostProcessing } = await import('./postProcessingFrameGraph.ts');
        await applyFrameGraphPostProcessing(scene, config);
    }
    else
    {
        applyPipelinePostProcessing(scene, config);
    }
}

//----------------------------------------------------------------------------------------------------------------------
